import useAppUserPermissions from 'hooks/useAppUserPermissions';

const usePropertiesUpdatingAllowed = () => {
  const permissions = useAppUserPermissions();
  return permissions.includes('Properties:Update');
};

export default usePropertiesUpdatingAllowed;
